module.exports = __webpack_public_path__ + "img/Allo Bank.5f53198a.png";